<template>
  <div class="content__column content__column--small" v-if="page">
    <h1 class="content__title">Editar / Crear Página</h1>
    <form class="form" @submit.prevent="savePage">
      <div class="form__fieldset">
        <div class="form__container">
          <label for="title" class="form__label form__label--required"
            >Título de la Página</label
          >
          <input
            type="text"
            class="form__input"
            name="title"
            id="title"
            v-model="page.title"
            v-validate="validation.title"
          />
          <span
            v-show="errors.has('title')"
            class="form__alert"
            v-text="errors.first('title')"
          ></span>
        </div>
        <div class="form__container">
          <label for="excerpt" class="form__label">Resumen de la Página</label>
          <textarea
            type="text"
            class="form__input"
            name="excerpt"
            id="excerpt"
            v-model="page.excerpt"
            v-validate="validation.excerpt"
          ></textarea>
          <span
            v-show="errors.has('excerpt')"
            class="form__alert"
            v-text="errors.first('excerpt')"
          ></span>
        </div>
        <div class="form__container">
          <label for="content" class="form__label">Contenido de la páina</label>
          <ckeditor
            :config="ckeconfig"
            v-model="page.content"
            v-validate="validation.content"
          ></ckeditor>
          <span
            v-show="errors.has('content')"
            class="form__alert"
            v-text="errors.first('content')"
          ></span>
        </div>
        <div class="form__container">
          <label class="form__label form__label--required" for="status_id">
            Estatus de la Página</label
          >
          <div class="form__select-container">
            <select
              name="status_id"
              id="status_id"
              class="form__select"
              v-validate="validation.status_id"
              v-model="page.status_id"
            >
              <option hidden :value="null">Seleccione un estatus</option>
              <option
                v-for="(status, index) in page_status"
                :key="index"
                :value="status.id"
                v-text="status.name"
              ></option>
            </select>
          </div>
          <span
            v-show="errors.has('status_id')"
            class="form__alert"
            v-text="errors.first('status_id')"
          ></span>
        </div>
        <div class="form__container">
          <label for="date" class="form__label form__label--required"
            >Fecha de Publicación</label
          >
          <input
            type="date"
            class="form__input"
            name="date"
            id="date"
            v-model="date"
            v-validate="validation.date"
          />
          <span
            v-show="errors.has('date')"
            class="form__alert"
            v-text="errors.first('date')"
          ></span>
        </div>
        <div class="form__container">
          <label for="time" class="form__label form__label--required"
            >Hora de Publicación</label
          >
          <input
            type="time"
            class="form__input"
            name="time"
            id="time"
            v-model="time"
            v-validate="validation.time"
          />
        </div>
        <div class="form__container">
          <div class="form__image form__image--wide">
            <label class="form__label" for="cover">Cover de la Página</label>
            <img :src="cover" alt="Page Cover" class="form__thumb" />
            <button
              class="btn btn__action btn--small"
              @click.prevent="showMedia = true"
            >
              Cargar Imagen
            </button>
            <button
              v-if="page.cover"
              class="btn btn__transparent btn--small"
              @click.prevent="cover = null"
            >
              Quitar Imagen
            </button>
          </div>
        </div>
      </div>
      <input
        type="submit"
        class="btn btn__action btn--regular"
        value="Guardar"
      />
      <button
        @click.prevent="$emit('new')"
        class="btn btn__transparent btn--regular"
      >
        Agregar Nueva Página
      </button>
    </form>
    <media-popup
      @close="showMedia = false"
      v-if="showMedia"
      field="cover"
    ></media-popup>
  </div>
</template>

<script>
import httpService from "@/core/api/request";
import { page_status } from "./mocks";
import mediaPopup from "@/components/media/popup";
import { config } from "@/core/config/base";
import Mixins from "./mixins";
import { ckeconfig } from "@/core/config/ckeditor";
import CKEditor from "ckeditor4-vue";
import { defaultDateFormat, defaultTimeFormat } from "@/core/libs/functions";

//window.CKEDITOR_BASEPATH = config.ckeditorUrl

export default {
  props: {
    page: {
      type: Object,
      required: false,
      default: function() {
        return {
          id: null,
          excerpt: null,
          title: null,
          content: null,
          status_id: null,
          cover: null,
          date: null
        };
      }
    }
  },
  mixins: [httpService, Mixins],
  components: {
    mediaPopup,
    ckeditor: CKEditor.component
  },
  data: function() {
    return {
      ckeconfig: ckeconfig,
      newImage: false,
      showMedia: false,
      page_status: page_status,
      validation: {
        title: "required|max:255",
        status_id: "required|min_value:1|max:4",
        date: "date_format:yyyy-MM-dd"
      }
    };
  },
  mounted: function() {
    this.$on("cover", media => {
      this.cover = media.image;
    });
  },
  methods: {
    savePage: function() {
      this.page.date = this.date;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.page.date = this.date + " " + this.time;
          let httpRequest = {
            params: "",
            module: "pages",
            element: this.page
          };
          let action;
          if (this.page.id) {
            action = this.put(this.page.id, httpRequest);
          } else {
            action = this.post(httpRequest);
          }
          action
            .then(response => {
              if (!this.page.id) {
                this.page.id = response.data.current_id;
              }
              this.$store.commit("elementChanged", {
                module: "pageEdit",
                time: Math.round(new Date().getTime() / 1000)
              });
              this.$store.commit("notificate", {
                title: "PÁGINA GUARDADA",
                text: "La página ha sido guardada correctamente",
                type: "success"
              });
            })
            .catch(() => {
              this.$store.commit("notificate", {
                title: "PÁGINA NO GUARDADA",
                text:
                  "La página no ha sido guardada, por favor, intente más tarde",
                type: "error"
              });
            });
        }
      });
    }
  },
  computed: {
    cover: {
      get: function() {
        if (this.page.cover) {
          let image = undefined;
          if (this.newImage) {
            image = this.page.cover;
          } else {
            image = JSON.parse(this.page.cover);
          }
          return config.statics.url + image.sizes.small;
        } else {
          return config.statics.dummy;
        }
      },
      set: function(value) {
        this.newImage = true;
        this.page.cover = value;
      }
    },
    date: function() {
      if (this.page.date) {
        return defaultDateFormat(new Date(this.page.date));
      } else {
        return defaultDateFormat(new Date());
      }
    },
    time: function() {
      if (this.page.date) {
        return defaultTimeFormat(new Date(this.page.date));
      } else {
        return defaultTimeFormat(new Date());
      }
    }
  }
};
</script>

<style lang="sass">
@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/pages/edit.vue